import { get } from 'lodash';

export class BasicDetailsForm {
  public dob: { day?: number, month?: number, year?: number };
  public gender: string | undefined;
  public smoker: string | undefined;
  public required1: boolean;
  public required2: boolean;
  public planStructure: { value?: string, description?: string };
  public scheme: string | undefined;
  
  constructor(initial: any) {
    this.dob = get(initial, 'dob', { day: undefined, month: undefined, year: undefined });
    this.gender = get(initial, 'gender', undefined);
    this.smoker = get(initial, 'smoker', undefined);
    this.required1 = get(initial, 'required1', false);
    this.required2 = get(initial, 'required2', false);
    this.scheme = get(initial, 'scheme', undefined);
    this.planStructure = get(initial, 'planStructure', { value: undefined, description: undefined });
  }
}